import * as React from "react";
import * as Modal from "react-modal";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import * as warningIcon from "../../iconic/warning.svg";

interface IErrorModalProps extends ITranslationProps {
    isOpen: boolean;
    onRequestClose: () => void;
    title: string;
    errors: string[];
}

function ErrorModal(p: IErrorModalProps) {

    function okClick() {
        p.onRequestClose();
    }

    const errorNodes: React.ReactNode[] = [];
    p.errors.forEach((errorMessage, idx) => {
        errorNodes.push(<li key={idx}>{errorMessage}</li>);
    });

    return (
        <Modal isOpen={p.isOpen}
            onRequestClose={p.onRequestClose}
            style={{
                content: {
                    position: "relative",
                    top: "auto",
                    bottom: "auto",
                    left: "auto",
                    right: "auto",
                    maxWidth: "500px",
                    margin: "1.75rem auto",
                    padding: "10px"
                },
                overlay: {
                    zIndex: 10
                }
            }}>
            <div className="modal-header">
                <img src={warningIcon} style={{ width: "30px" }} />
                <h5 className="modal-title ml-1">{p.title}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={p.onRequestClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="alert alert-danger">
                    <ul className="my-0">
                        {errorNodes}
                    </ul>
                </div>
            </div>
            <div className="modal-footer">
                <button data-id="error-button-ok" type="button" className="btn btn-secondary px-4" onClick={okClick}>{p.t("Global.OK")}</button>
            </div>

        </Modal>
    );
}

export default translateComponent(ErrorModal);



// WEBPACK FOOTER //
// ./src/core/ErrorModal/ErrorModal.tsx